import React from "react";
import ColouredBorderBox from "@Components/ColouredBorderBox";
import CloseIcon from "@Components/Icons/Close";
import InfoPopup from "@Components/InfoPopup";
import UsageUpload from "@Components/UsageUpload";
import HowToGetBills from "@SmartComponents/TenderEdit/Display/Boxes/HowToGetBills";
import TreatData from "@SmartComponents/TenderEdit/Display/Boxes/TreatData";
import styles from "./index.module.scss";
export default class AddUsage extends React.Component {
    render() {
        const isMobileTablet = window.innerWidth < 1410;
        const popup = (close) => {
            if (isMobileTablet) {
                return (React.createElement("div", { className: styles.mobilePopupWrapper },
                    React.createElement("button", { className: styles.closeButton, onClick: close, "aria-label": "Close", type: "button" },
                        React.createElement(CloseIcon, { size: "24px", color: "#98a2b3" })),
                    React.createElement("div", { className: styles.mobileContent },
                        React.createElement("div", { className: styles.mobileSection },
                            React.createElement(TreatData, null)),
                        React.createElement("div", { className: styles.mobileSection },
                            React.createElement("div", { className: styles.usageUpload },
                                React.createElement("div", { className: styles.mobileTitle },
                                    React.createElement("span", { className: styles.primaryColor }, "Bill Report"),
                                    React.createElement("span", null,
                                        " ",
                                        "upload, recommended for best-fit Tender results")),
                                React.createElement(UsageUpload, { submitPlatform: this.props.submitPlatform, submitFiles: this.props.submitFiles, grey: true, dataRequired: true, close: close }))),
                        React.createElement("div", { className: styles.mobileSection },
                            React.createElement(HowToGetBills, null)))));
            }
            return (React.createElement("div", { className: styles.popupWrapper },
                React.createElement("div", { className: styles.outerBox },
                    React.createElement(TreatData, { className: styles.outerBoxContent })),
                React.createElement("div", { className: styles.centreBox },
                    React.createElement(ColouredBorderBox, { className: styles.centreBoxContent, primary: true, title: React.createElement("div", { className: styles.title },
                            React.createElement("span", { className: styles.primaryColor }, "Bill Report"),
                            React.createElement("span", null,
                                " ",
                                "upload, recommended for best-fit Tender results")) },
                        React.createElement("button", { className: styles.closeButton, onClick: close, "aria-label": "Close", type: "button" },
                            React.createElement(CloseIcon, { size: "24px", color: "#98a2b3" })),
                        React.createElement("div", { className: styles.usageUpload },
                            React.createElement(UsageUpload, { submitPlatform: this.props.submitPlatform, submitFiles: this.props.submitFiles, grey: true, dataRequired: true, close: close })))),
                React.createElement("div", { className: styles.outerBox },
                    React.createElement(HowToGetBills, { className: styles.outerBoxContent }))));
        };
        let left = "unset";
        if (window.innerWidth >= 1715) {
            const middleOfScreen = window.innerWidth / 2;
            left = (this.props.middle || middleOfScreen) - middleOfScreen;
        }
        return (React.createElement(InfoPopup, { styles: {
                left,
                width: isMobileTablet ? "100%" : undefined,
                maxWidth: isMobileTablet ? "100%" : undefined,
                margin: isMobileTablet ? "0" : "auto",
            }, overlayStyles: isMobileTablet
                ? {
                    padding: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }
                : undefined, trigger: this.props.open === true, content: popup, onClose: this.props.onClose }));
    }
}
